import styled from 'styled-components'
import theme from 'theme_'
import { Font14 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'
import { CommonLinkButton } from 'components/Button'
import {
  HomeConfigActionCellProgressBar,
  HomeConfigFilesMobileDeployingContainer,
  HomeConfigFilesMobileProgressContainer,
} from '../../HomeConfiguration/HomeConfigFiles/styles'

export const StyledSoftwareUpdatesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
  @media ${theme.devices.tablet} {
    margin-bottom: 16px;
  }
`

export const StyledSoftwareUpdatesInfo = styled.div`
  width: 100%;
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template: 1fr / 1fr 1fr;
  @media ${theme.devices.mobile} {
    grid-template: 1fr 1fr / 1fr;
  }
`

export const StyledSoftwareName = styled.div`
  align-items: center;
  display: flex;
  ${Font14};
  font-weight: 600;

  span {
    color: ${theme.colors.otterWarmBlack};
    flex: 1;
    margin-left: 20px;
  }
`

export const SoftwareMobileTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing.tiny};
`

export const SoftwareMobileContainer = styled(WhiteBlock)<{
  progress?: number
}>`
  width: 100%;
  gap: ${theme.spacing.base};
  ${Font14};
  ${({ progress }) =>
    progress &&
    `
      background: ${theme.colors.hover10};
      border: 1px solid rgba(255, 95, 0, 0.5);
    `}
`

export const HomeSoftwareVersionContainer = styled.div`
  padding: ${theme.spacing.xxl} 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  align-items: center;
`

export const SoftwareUpdatesMobileKebabContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 10px;
  > button svg {
    display: none;
  }
`

export const SoftwareUpdatesMobileInstallWrapper = styled(CommonLinkButton)``

export const SoftwareUpdatesMobileInstallContainer = styled.div`
  display: flex;
`

export const SoftwareMobileInstallContainer = styled(
  HomeConfigFilesMobileDeployingContainer
)``
export const SoftwareMobileProgressContainer = styled(
  HomeConfigFilesMobileProgressContainer
)``
export const SoftwareMobileProgressBar = styled(
  HomeConfigActionCellProgressBar
)``
